import Index from '@future_chance/index.vue'

export default {
  path: 'future-chance',
  component: Index,
  children: [
    {
      name: 'FutureChance',
      path: 'list',
      meta: {
        title: '投资日历'
      },
      component: () => import('@future_chance/future_chance.vue')
    },
    {
      name: 'FutureChanceDetail',
      path: 'detail/:type/:id',
      meta: {
        title: '事件掘金'
      },
      component: () => import('@future_chance/event_detail.vue')
    },
    {
      path: 'report-detail/:type/:id',
      name: 'ReportDetail',
      component: () => import('@future_chance/report_detail.vue')
    },
    {
      name: 'FutureChanceStock',
      path: 'stock',
      component: () => import('@future_chance/stock_detail.vue')
    },
    {
      name: 'FutureChanceHistory',
      path: 'history',
      meta: {
        title: '历史事件'
      },
      component: () => import('@future_chance/history_list.vue')
    }
  ]
}
